export default __webpack_public_path__ + "static/media/family-BG.906279f3.png";